class ConfigurationsService {
    constructor() {
        this.baseURL = process.env.REACT_APP_WC_SITE_URL;
        this.isLoading = false;
    }

    async getConfigurations() {
        if(this.isLoading) return;
        this.isLoading = true;
        const user = JSON.parse(sessionStorage.getItem('user'));
        const response = await fetch(`${this.baseURL}/wp-json/rodlew_app/v1/configurations`, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token,
                'Content-Type': 'application/json'
            }
        });
        const data = await response.json();
        this.isLoading = false;
        return await data;
    }

    async createConfiguration(configurationData) {
        const user = JSON.parse(sessionStorage.getItem('user'));

        configurationData.date = new Date().toISOString();
        const response = await fetch(`${this.baseURL}/wp-json/rodlew_app/v1/configurations`, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + user.token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(configurationData)
        });
        return await response.json();
    }

    async editConfiguration(id, configurationData) {
        const user = JSON.parse(sessionStorage.getItem('user'));
        const response = await fetch(`${this.baseURL}/wp-json/rodlew_app/v1/configurations/${id}`, {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + user.token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(configurationData)
        });
        return await response.json();
    }

    async deleteConfiguration(id) {
        const user = JSON.parse(sessionStorage.getItem('user'));
        const response = await fetch(`${this.baseURL}/wp-json/rodlew_app/v1/configurations/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token,
                'Content-Type': 'application/json'
            }
        });
        return await response.json();
    }

    async createConfigurationForNotLoggedInUsers(configurationData) {
        const response = await fetch(`${this.baseURL}/wp-json/rodlew_app/v1/configurationsNotLoggedIn`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(configurationData)
        });
        return await response.json();
    }

    async getConfigurationForNotLoggedInUsers(uuid) {
        const response = await fetch(`${this.baseURL}/wp-json/rodlew_app/v1/configurationsNotLoggedIn/${uuid}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return await response.json();
    }

}

export default ConfigurationsService;